import {
  ADD_NEW_FOLDER_FROM_MOVE_MODAL,
  CLEAR_CHECKED_ITEMS,
  CLOSE_DASHBOARD_CARD_DROPDOWNS,
  CREATE_NEW_FOLDER_FAILED,
  CREATE_NEW_FOLDER_HIDE,
  CREATE_NEW_FOLDER_LOAD,
  CREATE_NEW_FOLDER_SHOW,
  CREATE_NEW_FOLDER_SUCCESS,
  CREATE_NEW_FOLDER_UPDATE_NAME,
  DASHBOARD_INIT,
  DISCARD_RENAME_CARD,
  FETCH_FAVORITES,
  FETCH_FOLDERS,
  FETCH_HIERARCHY,
  FETCH_SHARED_ITEMS,
  FETCH_TOP_LEVEL_FOLDERS,
  FETCH_VIDEOS,
  FOLDER_DESCRIPTION_CHANGED,
  FOLDER_DESCRIPTION_EDITED,
  FOLDER_DESCRIPTION_EDITING,
  REMOVE_FOLDERS,
  REMOVE_VIDEOS,
  RENAME_CARD,
  RESET_VIDEOS,
  RESTORE_FROM_PAST,
  SHARE_FOLDER_FAILED,
  SHARE_FOLDER_HIDE_MODAL,
  SHARE_FOLDER_LOADING,
  SHARE_FOLDER_SHOW_MODAL,
  SHARE_FOLDER_SUCCESS,
  SHOW_DASHBOARD_CARD_DROPDOWN,
  TOGGLE_DASHBOARD_UPGRADE_MODAL,
  TOGGLE_LOOM_DOWNLOAD_MODAL,
  TOGGLE_RECORD_TO_NON_DEFAULT_WORKSPACE_MODAL,
  TOGGLE_SIDEBAR_COLLAPSED,
  UNSHARE_FOLDER_FAILED,
  UNSHARE_FOLDER_LOADING,
  UNSHARE_FOLDER_SUCCESS,
  UPDATE_ALL_RECENT_VIDEOS_FETCHED,
  UPDATE_ALL_VIDEOS_FETCHED,
  UPDATE_BREADCRUMBS,
  UPDATE_CHECKED_ITEMS,
  UPDATE_CURRENT_FOLDER_INFO,
  UPDATE_DRAGGING_ITEMS,
  UPDATE_DRAGGING_MULTIPLE,
  UPDATE_FAVORITES,
  UPDATE_FOLDER_CHANGES_PENDING,
  UPDATE_FOLDER_NAME,
  UPDATE_FOLDER_TO_MOVE_TO,
  UPDATE_FOLDERS,
  UPDATE_FOLDERS_ERROR,
  UPDATE_FOLDERS_HIERARCHY,
  UPDATE_HAS_FETCHED_RECENT_TEAM_VIDEOS,
  UPDATE_IS_ARCHIVED,
  UPDATE_IS_FAVORITE,
  UPDATE_IS_FAVORITES_PAGE,
  UPDATE_IS_JTBD,
  UPDATE_IS_SHARED_WITH_ME_PAGE,
  UPDATE_PAGE_TYPE,
  UPDATE_PAST,
  UPDATE_PAST_FOLDER_NAME,
  UPDATE_RECENT_TEAM_VIDEOS,
  UPDATE_SELECTED_SUB_HEADER,
  UPDATE_SELECTED_WORKSPACE,
  UPDATE_SHOW_MOVE_MODAL,
  UPDATE_TOP_LEVEL_FOLDERS,
  UPDATE_TOTAL_VIDEO_COUNT,
  UPDATE_USER_FAVORITE_FOLDER,
  UPDATE_USER_FAVORITE_VIDEO,
  UPDATE_VIDEO_NAME,
  UPDATE_VIDEOS,
  UPDATE_VIDEOS_ERROR,
  UPDATE_VIDEOS_GRID,
  UPDATE_WELCOME_LOOMS,
  UPDATE_WELCOME_LOOMS_FETCHED,
  UPDATE_WELCOME_PERSONA_TEXT,
  UPDATE_WORKSPACE_LIBRARY_VIDEO_COUNTS,
} from '../constants/actions';

export const dashboardInit = (rootIsPublic, rootFolderId) => {
  return { type: DASHBOARD_INIT, rootIsPublic, rootFolderId };
};

export const closeDropdowns = () => {
  return { type: CLOSE_DASHBOARD_CARD_DROPDOWNS };
};

export const discardRenameCard = () => {
  return { type: DISCARD_RENAME_CARD };
};

export const fetchSharedItems = () => {
  return { type: FETCH_SHARED_ITEMS };
};

export const fetchFavorites = () => {
  return { type: FETCH_FAVORITES };
};

export const fetchFolders = () => {
  return { type: FETCH_FOLDERS };
};

export const fetchHierarchy = () => {
  return { type: FETCH_HIERARCHY };
};

export const fetchTopLevelFolders = () => {
  return { type: FETCH_TOP_LEVEL_FOLDERS };
};

export const fetchVideos = () => {
  return { type: FETCH_VIDEOS };
};

export const renameCard = id => {
  return {
    type: RENAME_CARD,
    id,
  };
};

export const resetVideos = () => {
  return { type: RESET_VIDEOS };
};

export const restoreFromPast = () => {
  return { type: RESTORE_FROM_PAST };
};

export const showDropdown = id => {
  return {
    type: SHOW_DASHBOARD_CARD_DROPDOWN,
    id,
  };
};

export const updateAllVideosFetched = allVideosFetched => {
  return {
    type: UPDATE_ALL_VIDEOS_FETCHED,
    allVideosFetched,
  };
};

export const updateAllRecentVideosFetched = allRecentVideosFetched => {
  return {
    type: UPDATE_ALL_RECENT_VIDEOS_FETCHED,
    allRecentVideosFetched,
  };
};

export const updateWelcomeLoomsFetched = welcomeLoomsFetched => {
  return {
    type: UPDATE_WELCOME_LOOMS_FETCHED,
    welcomeLoomsFetched,
  };
};

export const updateBreadcrumbs = breadcrumbs => {
  return {
    type: UPDATE_BREADCRUMBS,
    breadcrumbs,
  };
};

export const updateCheckedItems = checkedItems => {
  return {
    type: UPDATE_CHECKED_ITEMS,
    checkedItems,
  };
};

export const updateCurrentFolderInfo = folder => {
  return {
    type: UPDATE_CURRENT_FOLDER_INFO,
    specialId: folder.specialId,
    favorite: folder.favorite,
    id: folder.id,
    name: folder.name,
    description: folder.description,
    parentId: folder.parentId,
    ownerId: folder.ownerId,
    shared: folder.shared,
    collaborators: folder.collaborators || [],
    owner: folder.owner || {},
  };
};

export const updateDraggingMultiple = draggingMultiple => {
  return {
    type: UPDATE_DRAGGING_MULTIPLE,
    draggingMultiple,
  };
};

export const updateDraggingItems = dragging => {
  return {
    type: UPDATE_DRAGGING_ITEMS,
    dragging,
  };
};

export const updateFavorites = favorites => {
  return {
    type: UPDATE_FAVORITES,
    favorites,
  };
};

export const updateHasFetchedRecentTeamVideos = hasFetchedRecentTeamVideos => {
  return {
    type: UPDATE_HAS_FETCHED_RECENT_TEAM_VIDEOS,
    hasFetchedRecentTeamVideos,
  };
};

export const updateFolderName = (id, newName) => {
  return {
    type: UPDATE_FOLDER_NAME,
    id,
    newName,
  };
};

export const updateFolderChangesPending = pending => {
  return {
    type: UPDATE_FOLDER_CHANGES_PENDING,
    pending,
  };
};

export const updateFolders = folders => {
  return {
    type: UPDATE_FOLDERS,
    folders,
  };
};

export const updateFoldersError = err => {
  return {
    type: UPDATE_FOLDERS_ERROR,
    err,
  };
};

export const updateFoldersHierarchy = hierarchy => {
  return {
    type: UPDATE_FOLDERS_HIERARCHY,
    hierarchy,
  };
};

export const updateIsArchived = archived => {
  return {
    type: UPDATE_IS_ARCHIVED,
    archived,
  };
};

export const updateIsFavoritesPage = isFavorites => {
  return {
    type: UPDATE_IS_FAVORITES_PAGE,
    isFavorites,
  };
};

export const updateIsSharedWithMePage = isSharedWithMePage => {
  return {
    type: UPDATE_IS_SHARED_WITH_ME_PAGE,
    isSharedWithMePage,
  };
};

export const updateIsFavorite = favorite => {
  return {
    type: UPDATE_IS_FAVORITE,
    favorite,
  };
};

export const updateIsJTBD = isJTBD => {
  return {
    type: UPDATE_IS_JTBD,
    isJTBD,
  };
};

export const updateFolderToMoveTo = folder => {
  return {
    type: UPDATE_FOLDER_TO_MOVE_TO,
    folder,
  };
};

export const updatePast = past => {
  return {
    type: UPDATE_PAST,
    past,
  };
};

export const updateRecentTeamVideos = videos => {
  return {
    type: UPDATE_RECENT_TEAM_VIDEOS,
    videos,
  };
};

export const updateShowMoveModal = show => {
  return {
    type: UPDATE_SHOW_MOVE_MODAL,
    show,
  };
};

export const updateTopLevelFolders = folders => {
  return {
    type: UPDATE_TOP_LEVEL_FOLDERS,
    folders,
  };
};

export const updateVideoName = (id, newName) => {
  return {
    type: UPDATE_VIDEO_NAME,
    id,
    newName,
  };
};

export const updateVideos = videos => {
  return {
    type: UPDATE_VIDEOS,
    videos,
  };
};

export const updateVideosError = err => {
  return {
    type: UPDATE_VIDEOS_ERROR,
    err,
  };
};

export const updateVideosGrid = videos => {
  return {
    type: UPDATE_VIDEOS_GRID,
    videos,
  };
};

export const createNewFolderShow = () => {
  return { type: CREATE_NEW_FOLDER_SHOW };
};

export const createNewFolderUpdateName = name => {
  return { type: CREATE_NEW_FOLDER_UPDATE_NAME, name };
};

export const createNewFolderHide = () => {
  return { type: CREATE_NEW_FOLDER_HIDE };
};

export const createNewFolderLoad = (
  parent_folder_id,
  folder_name,
  local_id
) => {
  return {
    type: CREATE_NEW_FOLDER_LOAD,
    parent_folder_id,
    folder_name,
    local_id,
  };
};

export const createNewFolderFailed = () => {
  return { type: CREATE_NEW_FOLDER_FAILED, name };
};

export const createNewFolderSuccess = folder => {
  return { type: CREATE_NEW_FOLDER_SUCCESS, folder };
};

export function showShareFolderModal(id) {
  return { type: SHARE_FOLDER_SHOW_MODAL, id };
}

export function hideShareFolderModal() {
  return { type: SHARE_FOLDER_HIDE_MODAL };
}

export function shareFolderFailed(error) {
  return { type: SHARE_FOLDER_FAILED, error };
}

export function shareFolderLoading(id, name) {
  return { type: SHARE_FOLDER_LOADING, id, name };
}

export function shareFolderSuccess(folderId) {
  return { type: SHARE_FOLDER_SUCCESS, folderId };
}

export function unshareFolderFailed(error) {
  return { type: UNSHARE_FOLDER_FAILED, error };
}

export function toggleLoomDownloadModal(show) {
  return {
    type: TOGGLE_LOOM_DOWNLOAD_MODAL,
    payload: {
      show,
    },
  };
}

export function toggleRecordToNonDefaultWorkspaceModal(show) {
  return {
    type: TOGGLE_RECORD_TO_NON_DEFAULT_WORKSPACE_MODAL,
    payload: {
      show,
    },
  };
}

export function unshareFolderSuccess(folderId) {
  return { type: UNSHARE_FOLDER_SUCCESS, folderId };
}

export function unshareFolderLoading(id) {
  return { type: UNSHARE_FOLDER_LOADING, id };
}

export function folderDescriptionEditing() {
  return { type: FOLDER_DESCRIPTION_EDITING };
}

export function folderDescriptionChanged(description) {
  return { type: FOLDER_DESCRIPTION_CHANGED, description };
}

export function folderDescriptionEdited() {
  return { type: FOLDER_DESCRIPTION_EDITED };
}

export function updateTotalVideoCount(count) {
  return { type: UPDATE_TOTAL_VIDEO_COUNT, count };
}

export function toggleDashboardUpgradeModal(showModal) {
  return { type: TOGGLE_DASHBOARD_UPGRADE_MODAL, showModal };
}

export function updateSelectedWorkspace(workspace) {
  return { type: UPDATE_SELECTED_WORKSPACE, workspace };
}

export function toggleSidebarCollapsed(isCollapsed) {
  return { type: TOGGLE_SIDEBAR_COLLAPSED, isCollapsed };
}

export function removeFolders(folderIds) {
  return { type: REMOVE_FOLDERS, folderIds };
}

export function removeVideos(videoIds) {
  return { type: REMOVE_VIDEOS, videoIds };
}

export function clearCheckedItems() {
  return { type: CLEAR_CHECKED_ITEMS };
}

export function updatePastFolderName(id, name) {
  return { type: UPDATE_PAST_FOLDER_NAME, id, name };
}

export function updateSelectedSubHeader(subHeader) {
  return { type: UPDATE_SELECTED_SUB_HEADER, subHeader };
}

export function addNewFolderFromMoveModal(folder) {
  return { type: ADD_NEW_FOLDER_FROM_MOVE_MODAL, folder };
}

export function updateUserFavoriteFolder(folderId, isFavorite) {
  return { type: UPDATE_USER_FAVORITE_FOLDER, folderId, isFavorite };
}

export function updateUserFavoriteVideo(videoId, isFavorite) {
  return { type: UPDATE_USER_FAVORITE_VIDEO, videoId, isFavorite };
}

export function updatePageType(pageType, isRoot = false) {
  return { type: UPDATE_PAGE_TYPE, pageType, isRoot };
}

export function updateWorkspaceLibraryVideoCounts(counts) {
  return {
    type: UPDATE_WORKSPACE_LIBRARY_VIDEO_COUNTS,
    counts,
  };
}

export function updateWelcomeLooms(welcomeLooms) {
  return {
    type: UPDATE_WELCOME_LOOMS,
    welcomeLooms,
  };
}

export function updateWelcomePersonaText(welcomePersonaText) {
  return {
    type: UPDATE_WELCOME_PERSONA_TEXT,
    welcomePersonaText,
  };
}
